<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" :isChildren="true" :head-bg="'#02305f'" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div slot="slogan">
      <div class="user-avatar">
        <Avatar :src="headImage" size="large"/>
        <h5>{{formItem.nickname||formItem.username}}</h5>
      </div>
      <p class="user-job-number">NO: {{formItem.job_number}}</p>
    </div>
    <div class="activity-item mgui-container" :slot="'/user/view/'+userId">
      <user-edit-form :data="formItem" @change="userChange" @update="updateJobNumber"></user-edit-form>
    </div>
    <div class="activity-item mgui-container" :slot="'/user/resume/'+userId">
      <user-resume :resumeData="userResume" :resumeFiles="resumeFiles"></user-resume>
    </div>
  </content-layout>
</template>


<script>
  import {fetch} from '../fetch/api'

  // const modelName = 'user'

  function prefixInteger (num, n) {
    return (Array(n).join(0) + num).slice(-n)
  }

  export default {
    name: 'ActivityUserView',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) },
      UserEditForm: resolve => { require(['../components/UserEditFormComponent'], resolve) },
      UserResume: resolve => { require(['../components/UserResume'], resolve) }
    },
    data () {
      let token = localStorage.getItem('token')
      return {
        token: token,
        userId: 0,
        title: '详情资料',
        userResume: {},
        resumeFiles: {},
        tabs: [],
        activeTab: '/user/view',
        groupData: [],
        spinShow: true,
        formItem: {},
        headImage: null
      }
    },
    watch: {
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      this.userId = this.$route.params.id
      setTimeout(() => {
        this.fetchData()
      }, 400)
      this.tabs = [
        {'title': '员工详情', 'key': '/user/view/' + this.userId, 'visible': true},
        {'title': '简历', 'key': '/user/resume/' + this.userId, 'visible': this.$store.state.userInfo.role !== 5}
      ]
      this.routeChange(this.$route)
    },
    methods: {
      routeChange (route) {
        let action = route.params.action
        if (action === 'view') {
          this.activeTab = `/user/view/${this.userId}`
          this.spinShow = false
          this.fetchData()
        }
        if (action === 'resume') {
          this.activeTab = `/user/resume/${this.userId}`
          this.spinShow = false
          this.fetchEntryInfo()
        }
      },
      fetchEntryInfo () {
        let uid = this.$route.params.id
        fetch(`/users/entry/info/${uid}`).then(res => {
          if (res.status === 'ok') {
            let data = res.resume
            if (data !== null) {
              data['edu_exp'] = JSON.parse(data['edu_exp'])
              data['work_exp'] = JSON.parse(data['work_exp'])
              // data['special_skill'] = JSON.parse(data['special_skill'])
              data['certificate'] = JSON.parse(data['certificate'])
              data['content'] = JSON.parse(data['content'])
              data['family'] = JSON.parse(data['family'])
              data['bank'] = (data['bank'] === null || data['bank'] === '') ? {} : JSON.parse(data['bank'])
              this.userResume = data
            }
            if (res.files !== null) {
              for (let k in res.files) {
                let _file = res.files[k]
                if (_file.file_type === 'id_card_f') this.resumeFiles.id_card_f = this.getImage(_file.file_path)
                if (_file.file_type === 'id_card_b') this.resumeFiles.id_card_b = this.getImage(_file.file_path)
                if (_file.file_type === 'education_certificate') this.resumeFiles.education_certificate = this.getImage(_file.file_path)
                if (_file.file_type === 'degree_certificate') this.resumeFiles.degree_certificate = this.getImage(_file.file_path)
              }
            }
            // if (res.contract !== null) {
            //   this.contractData = JSON.parse(res.contract.sign_info)
            //   this.contractPath = `${this.apiPath}/api/console/pdf?type=pdf&path=${res.contract.file_path}&token=${this.token}`
            // }

            // this.isToExamine = res.entry_status === 2
            // if (res.entry_info !== null) {
            //   this.entryInfo = res.entry_info
            //   this.entryInfo.time_limit = Number(this.entryInfo.time_limit)
            //   this.entryInfo.job_name = this.entryInfo.job_name.split('/')
            //   this.is_social_security = this.entryInfo.social_security === '无社保' ? 0 : 1
            // }
          }
        })
      },
      userChange (ids) {
        let number = this.getNumber(ids[0])
        let jobNumber = this.formItem.job_number
        if (jobNumber.length >= 6) {
          jobNumber = jobNumber.substr(2, jobNumber.length)
        } else {
          jobNumber = prefixInteger(this.formItem.id, 4)
        }
        this.formItem.job_number = '8' + number + '' + jobNumber
      },
      getNumber (id) {
        let number
        for (let k in this.$store.state.department) {
          if (this.$store.state.department[k].value === id) {
            number = this.$store.state.department[k].number
            break
          }
        }
        return number
      },
      getImage (path) {
        return `/api/console/file?path=${path}&token=${this.token}`
      },
      updateJobNumber (did) {
        let number = this.getNumber(did[0])
        let jobNumber = prefixInteger(this.formItem.id, 4)
        this.formItem.job_number = '8' + number + '' + jobNumber
      },
      fetchData () {
        if (this.userId === 0) return
        fetch(`users/${this.userId}`).then(res => {
          let data = res
          let ids = JSON.parse(data['department_id'])
          // let arr = []
          let number = this.getNumber(ids[0])
          data['department_id'] = ids
          if (data.job_number === '0000') data.job_number = '8' + number + '' + prefixInteger(data.id, 4)
          this.formItem = data
          this.headImage = (res.image === '' || res.image === null) ? '/static/images/logo.svg' : res.image
          this.spinShow = false
        })
      }
    }
  }
</script>

<style scoped>
  .user-avatar{background: #fff;padding: 0 10px}
  .user-avatar,.user-job-number{
    height: 80px;
    border-radius: 80px;
    position: absolute;
    bottom: -40px;
    left: 50%;
    margin-left: -40px;
    z-index: 100;
  }
  .user-avatar .ivu-avatar-image,
  .user-avatar .ivu-avatar-large{
    width: 80px;
    height: 80px;
    border-radius: 90px
  }
  .user-avatar h5{color:#333;text-align: center}
  .user-job-number{
    width: auto;
    left: auto;
    top: auto;
    bottom: 10px;
    height: 20px;
    right: 0;
    color: #fff;
    font-size: 16px;
    text-align: right;
    padding-right: 20px;
  }
  .user-detail{
    padding-top: 60px;
    padding-right: 40px;
  }
  @media (max-width: 640px) {
    .user-avatar{
      bottom: auto;
      height: 60px;
      top: 20px;
      left: 20px;
      margin-left: 0;
    }
    .user-avatar h5{margin-left:10px;color:#fff;font-size:16px;display: inline-block;text-align: left}
    .user-avatar .ivu-avatar-image{
      width: 60px;
      height: 60px;
    }
    /*.user-job-number{position: static;text-align: left;margin-left: 10px;}*/
  }
</style>
